import { useAuth0 } from '@auth0/auth0-react'
import { getSsoConnection } from '../utils/authSource'

// SSO users have no password, so they go to a logged-out page instead of straight back into a login
export const useLogout = () => {
  const { logout } = useAuth0()

  return () => {
    const returnTo = getSsoConnection() ? `${window.location.origin}/logged-out` : window.location.origin
    logout({ logoutParams: { returnTo } })
  }
}
